import React from 'react';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';

import { Link } from '..';
import Carousel, { Props as CarouselProps } from '../carousel/carousel';

import TextCarouselTitle from './text-carousel-title';
import './text-carousel.scss';

const TextCarousel = ({
    data,
    breakpoints,
    title,
    icon,
    link,
    endTracking,
    linkTracking,
    trackingContext,
}: Props) => (
    <div className="text-carousel carousel">
        <TextCarouselTitle title={title} icon={icon} />
        <Carousel
            slides={data.map((text) => ({ type: 'html', content: <p>{text}</p> }))}
            breakpoints={breakpoints}
            itemsToShow={1}
            hasControls
            hasCounter
            endTracking={endTracking}
            trackingContext={trackingContext}
        />
        {link && (
            <Link
                href={link.href}
                text={link.text}
                className="carousel-link text-carousel-link"
                openInNewTab
                onClick={() => linkTracking && trackV2(linkTracking)}
            />
        )}
    </div>
);

interface Props extends Pick<CarouselProps, 'breakpoints' | 'endTracking' | 'trackingContext'> {
    data: string[];
    icon: object;
    link: {
        href: string;
        text: string;
    };
    linkTracking: string;
    title: string;
}

TextCarousel.defaultProps = {
    data: [],
    endTracking: '',
    breakpoints: [],
    icon: null,
    link: null,
    linkTracking: null,
    title: null,
};

export default TextCarousel;
